import MainCameraIOS from './MainCameraIOS';

export default MainCameraIOS;
